module.exports = __webpack_public_path__ + "img/welding-8.913a5188.jpg";